export var OS_INFO = {
  Windows: {
    downloadLink: "",
    icon: null,
    label: "Download exe"
  },
  MAC: {
    downloadLink: "https://github.com/crusherdev/crusher-downloads/releases/latest/download/crusher-recorder.dmg",
    icon: null,
    label: "Download dmg"
  },
  OTHER: {
    downloadLink: "",
    icon: null
  }
};
export var LINUX_INFO = {
  Linux_DEB: {
    downloadLink: "https://github.com/crusherdev/crusher-downloads/releases/latest/download/crusher-recorder.deb",
    icon: null,
    label: "Download deb"
  }
};
export var OS;

(function (OS) {
  OS["Windows"] = "Windows";
  OS["MAC"] = "MAC";
  OS["Linux"] = "Linux";
  OS["OTHER"] = "OTHER";
})(OS || (OS = {}));